import { GET } from 'common/helpers.ts';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

const HEALTH_CHECK_INTERVAL = 30000;

export const Maintenance = () => {
  const { t } = useTranslation();

  // Memoize the redirect parameter to prevent unnecessary re-renders
  const redirect = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('redirect');
  }, []);

  const { data } = useSWR(['/health'], GET, { refreshInterval: HEALTH_CHECK_INTERVAL });

  useEffect(() => {
    // Only redirect if maintenance is explicitly disabled and we have a valid redirect URL
    if (data?.is_under_maintenance === false && redirect && redirect !== '/maintenance') {
      window.location.href = redirect;
    }
  }, [data?.is_under_maintenance, redirect]);

  return (
    <main className="flex items-center justify-center">
      <div className="absolute inset-0 -z-30 flex flex-col items-center justify-center gap-8 bg-blue-light">
        <img src="/maintenance.svg" alt={t('maintenance.imageAlt')} />
        <h1 className="blue">{t('maintenance.title')}</h1>
        <p>{t('maintenance.subtitle')}</p>
      </div>
    </main>
  );
};
